import React from 'react';
import { Link } from 'react-router-dom';
import { PageTransition } from '../../components/ui/PageTransition';
import { SEO } from '../../components/shared/SEO';
import { LogoutButton } from '../../components/admin/LogoutButton';

export function AdminHome() {
  return (
    <PageTransition>
      <SEO
        title="Admin Home"
        description="KaizenMC Admin Panel"
        noindex={true}
      />
      <div className="min-h-screen bg-gray-900 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-white">Admin Panel</h1>
            <LogoutButton />
          </div>
          
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {/* Store Management Card */}
            <Link
              to="/admin/store"
              className="block p-6 bg-gray-800 rounded-lg border border-gray-700 hover:bg-gray-700 transition-colors"
            >
              <h2 className="text-xl font-semibold text-white mb-2">Store Management</h2>
              <p className="text-gray-400">
                Manage store products, transactions, and send actions
              </p>
            </Link>

            {/* Gamemode Images Card */}
            <Link
              to="/admin/images"
              className="block p-6 bg-gray-800 rounded-lg border border-gray-700 hover:bg-gray-700 transition-colors"
            >
              <h2 className="text-xl font-semibold text-white mb-2">Gamemode Images</h2>
              <p className="text-gray-400">
                Manage images for different gamemodes displayed on the home page
              </p>
            </Link>
          </div>
        </div>
      </div>
    </PageTransition>
  );
} 